<!--
  Copyright 2024 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<div class="page">
  <ground-header></ground-header>
  <div class="page-content">
    <h1 class="page-title">
      <ng-container i18n="@@app.labels.termsOfService"
        >Terms of service</ng-container
      >
    </h1>
    <div class="terms-text-container" [innerHTML]="termsOfServiceText"></div>
    <div class="action-buttons">
      @if (!hasAcceptedTos) {
        <mat-checkbox
          i18n="@@app.labels.agreeWithTermsOfService"
          [(ngModel)]="isTermsOfServiceChecked"
          >I have read and agree with terms of service.</mat-checkbox
        >
        <button
          mat-flat-button
          (click)="onContinueButtonClick()"
          [disabled]="!isTermsOfServiceChecked"
        >
          <ng-container i18n="@@app.labels.continue">Continue</ng-container>
        </button>
      } @else {
        <button mat-button color="primary" (click)="onBackButtonClick()">
          <mat-icon>arrow_back</mat-icon>
          <ng-container i18n="@@app.labels.back">Back</ng-container>
        </button>
      }
    </div>
  </div>
</div>
